import Autolinker from 'autolinker'
import _ from 'lodash'
import camelCase from '../util/camelCase';
import StickyAutoHideHeader from '../util/StickyAutoHideHeader';
import Fuwa from '../util/Fuwa';

export default {
  // サイト内で一度だけ実行
  initOnce(router) {

    this.router = router

    // ページスクロールの対象を調査
    document.screen_scroll_target = (!window.chrome && 'WebkitAppearance' in document.documentElement.style) ? $('body') : $('html')

    // ブラウザ判定
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/msie/i) || ua.match(/rident/i)) {
      var ieVersion = parseInt(ua.match(/((msie|MSIE)\s|rv:)([\d.]+)/)[3]);
      $('html').addClass(`ie ie${ieVersion}`);
    } else if (ua.match(/edge/i)) {
      $('html').addClass('edge');
    } else if (ua.match(/chrome/i)) {
      $('html').addClass('chrome');
    } else if (ua.match(/safari/i)) {
      $('html').addClass('safari');
    } else if (ua.match(/firefox/i)) {
      $('html').addClass('firefox');
    } else if (ua.match(/opera/i)) {
      $('html').addClass('opera');
    } else if (ua.match(/i(pad|phone|pod)/i)) {
      $('html').addClass('ios');
    }
    if ((ua.match(/i(pad|phone|pod)/i) || ua.match(/android/i)) && ua.match(/mobile/i) || ua.match(/ipad/i) || ua.match(/android/i)) {
      $('html').addClass('mobile');
    }
    if ((ua.match(/ipad/i) || !ua.match(/mobile/i)) && ua.match(/android/i)) {
      $('html').addClass('tablet');
    }

    // cursor
    const cursor = $('#cursorPointer')
    cursor.cursorElement()
    const target = 'a[href], a.pageTop, button, input, label, [data-modal], [data-src], #projectStory>.close, .closeProjectStory'
    $(document)
      // .on('click', target, (e) => {
      //   const el = $(e.target)
      //   if (!(el.is('.lg-prev') || el.is('.lg-next'))) {
      //     cursor.removeClass('active').removeAttr('data-icon')
      //   }
      // })
      .on('mouseenter', target, () => { cursor.addClass('active') })
      .on('mouseleave', target, () => { cursor.removeClass('active') })
      .on('mouseenter', 'a[target="_blank"]', () => { cursor.attr('data-icon', 'blank') })
      .on('mouseleave', 'a[target="_blank"]', () => { cursor.removeAttr('data-icon') })
      // [data-src] : lightGallery用
      .on('mouseenter', '[data-modal],[data-src]', () => { cursor.attr('data-icon', 'modal') })
      .on('mouseleave', '[data-modal],[data-src]', () => { cursor.removeAttr('data-icon') })
      // lightGalleryの矢印ボタン
      // .on('mouseenter', '.lg-prev', () => { cursor.attr('data-icon', 'prev') })
      // .on('mouseleave', '.lg-prev', () => { cursor.removeAttr('data-icon') })
      // .on('mouseenter', '.lg-next', () => { cursor.attr('data-icon', 'next') })
      // .on('mouseleave', '.lg-next', () => { cursor.removeAttr('data-icon') })
      // そのあいだのはなしのモーダルの外側
      .on('mouseenter', '#projectStory>.close', () => { cursor.attr('data-icon', 'close') })
      .on('mouseleave', '#projectStory>.close', () => { cursor.removeAttr('data-icon') })
    // ハンバーガーメニュー
      .on('click', '#ham, .modal_background', () => {
        $('#ham').toggleClass('open')
        this.onChangeGlobalNavVisiblity()
      })
    // modalの背景もしくは.closeBtnがクリックされた時
      .on('click', '#modal', (e) => {
        if ($(e.target).is('#modal') || $(e.target).closest('.closeBtn').length) {
          $('#modal').addClass('hide')
          setTimeout(()=> { $('#modal').removeAttr('class').empty() }, 400)
          $('body').removeClass('noscroll')
        }
      })
    // ページトップボタン
      .on('click', '.pageTop', () => {
        document.screen_scroll_target.animate({scrollTop: 0}, 1000)
      })

    // リサイズ時に、対応するroutesの関数を呼び出す
    $(window)
      .on('resize', _.debounce((e) => {
        this.fireEvent('resize', e)
      }, 100))

    // オートリンク
    const nl2br = function (str) {
      return str.replace(/\r\n/g, '<br>').replace(/(\n|\r)/g, '<br>')
    }
    $('[data-autolink]').each(function () {
      $(this).html(nl2br(new Autolinker({ stripPrefix: false }).link($(this).text())))
    })

    this.stickyAutoHideHeader = new StickyAutoHideHeader()
    this.fuwa = new Fuwa()
  },
  init() {
    this.initGlobalNav()
    // ラベルの書き換え
    if ($('#label').attr('href') !== $('h1.label a').attr('href')) { // 同じだったら何もしない
      const prev = $('h1.label a span')
      const next = $(`<span style="display: none;">${$('#label span').text()}</span>`)
      $('h1.label').attr('href', $('#label').attr('href'))
      $('h1.label a').append(next)
      next.fadeIn(1000)
      prev.fadeOut(1000, ()=> prev.remove())
    }
    // SPのグロナビ
    $('#ham').removeClass('open')
    this.onChangeGlobalNavVisiblity()
    this.stickyAutoHideHeader.init()
    this.fuwa.init()
  },
  // Public functions
  // 各ページのイベントを発火する
  fireEvent(eventName, arg) {
    // See util/Router.js:L56-L64
    document.body.className
      .toLowerCase()
      .replace(/-/g, '_')
      .split(/\s+/)
      .map(camelCase)
      .forEach((className) => {
        this.router.fire(className, eventName, arg);
      });
  },
  // selector で与えた要素の中のh2-h5要素を複数行に渡って下線がつくように.borderでwrapする
  enableMultipleLineBorderheading(selector) {
    $(selector).find('h2, h3, h4, h5').each(function () {
      $(this).wrapInner('<span class="border"></span>')
    })
  },
  // Private functions
  // グロナビのcurrentクラス付与、言語変わった時にリンク先変更
  initGlobalNav() {
    const lang = /^\/en\//.test(location.pathname) ? 'en' : 'ja'

    const matches = location.pathname.match(/^(\/(en\/)?[^/]*\/?)/)
    if (matches) {
      $('.gnav .contents a')
        .removeClass('current')
        .filter(`[data-href-${lang}="${matches[0]}"]`)
        .addClass('current')
    }
    // 言語ボタンのcurrentとリンク先を設定
    $('.gnav .languages a').each(function() {
      const me = $(this)
      if(me.hasClass(lang)) {
        me.addClass('current').removeAttr('href')
      } else {
        me.removeClass('current')
        // 対応するページがあれば設定、なければトップを指定
        const anotherLangPageUrl = lang === 'en' ? location.pathname.replace('/en', '') : `/en${location.pathname}`
        $.ajax({type: 'HEAD', url: anotherLangPageUrl})
          .done(function() {
            me.attr('href', anotherLangPageUrl)
          })
          .fail(function() {
            me.attr('href', lang === 'en' ? '/' : '/en/')
          })
      }
    })
  },
  changeGlobalNavHref(lang) {
    $('.gnav .contents a').each(function() {
      $(this).attr('href', $(this).attr(`data-href-${lang}`))
    })
  },
  // SPのグロナビの表示ステータスを他に伝搬するための処理
  onChangeGlobalNavVisiblity() {
    const gnav_visibility = $('#ham').hasClass('open')
    $('#global_header').css('top', 0).attr('data-sp_menu_visibility', gnav_visibility)
    $('body').toggleClass('noscroll', gnav_visibility)
  }
}
